import React, { Fragment, useEffect } from 'react';
import * as GoogleAnalytics from '../lib/google-analytics';
import MainLayout from '../components/layouts/MainLayout';
import CheckOutPaymentSuccess from '../components/views/CheckOutPaymentSuccess';

const CheckOutPaymentSuccessContainer = ({
  history,
  match,
}) => {
  useEffect(() => {
    GoogleAnalytics.customEvent({
      category: 'page_view',
      action: 'page_view_checkout_success',
    });
  }, []);

  return (
    <Fragment>
      <MainLayout
        history={history}
        ContentBody={(
          <CheckOutPaymentSuccess
            history={history}
          />
        )}
      />
    </Fragment>
  );
};

export default CheckOutPaymentSuccessContainer;